import { createSlice } from '@reduxjs/toolkit';
import { SearchStatus } from 'Utils/Constants/TotalTypes';

const globalSlice = createSlice({
    name : 'variables',
    initialState : {
        page: -1,
        loading: false,
        dateSearch: { date: '', dow: '' },
        maxd: 1,
        wallet: 0,
        extraCount: null,
        appointmentTypes: null,
        pos: null,
        message: null,
        totalStatuses: null,
        weeklyLimit: null,
        totalTimes: null,
        selected: null,
        create_new: { name: '', nCode: '', uniCode: '', mobile: '' },
        searchTypes: null,
        searchStatus: null,
        openStatusHistory: { open: false, tab: '1', data: null },
    },
    reducers : {
        setFirstData: (state , action) => {
            state.weeklyLimit = JSON.parse(action.payload.weeklyLimit);
            state.extraCount = +action.payload.extraCount;
            state.totalTimes = JSON.parse(action.payload.totalTimes);
            state.appointmentTypes = action.payload.appointmentTypes;
            state.pos = JSON.parse(action.payload.pos);
            state.message = JSON.parse(action.payload.message);
            state.totalStatuses = action.payload.totalStatuses;
            state.maxd = action.payload.maxd;
            state.wallet = action.payload.wallet;
            let sTypes = [];
            sTypes.push({
                id: 0,
                name: 'همه',
                access: action.payload.appointmentTypes.map(i => {return i.id}),
            })
            action.payload.users.filter(i => i.doctor).map((i, index) => {
                return sTypes.push({
                    id: (index+1),
                    name: i.name,
                    access: i.types,
                })
            })
            state.searchTypes = sTypes;
            let sStatuses = [];
            SearchStatus.map((items, index) => {
                if(action.payload.totalStatuses.map(i => {
                    if(items.access.includes(i.id) && i.status) return true;
                }).reduce((a, b) => {
                    if(a || b) return true;
                    else return false;
                })) {
                    sStatuses.push({
                        id: index,
                        name: items.name,
                        access: items.access.filter(j => {
                            return action.payload.totalStatuses.find(t => t.id === j).status
                        })
                    })
                }
            })
            state.searchStatus = sStatuses;
        },
        setDaysLimitsData: (state , action) => {
            state.weeklyLimit = JSON.parse(action.payload.weeklyLimit);
            state.extraCount = +action.payload.extraCount;
            state.totalTimes = JSON.parse(action.payload.totalTimes);
        },
        setAppointmentTypes: (state , action) => {
            state.appointmentTypes = action.payload.appointmentTypes;
            let sTypes = [];
            sTypes.push({
                id: 0,
                name: 'همه',
                access: action.payload.appointmentTypes.map(i => {return i.id}),
            })
            action.payload.users.filter(i => i.doctor).map((i, index) => {
                return sTypes.push({
                    id: (index+1),
                    name: i.name,
                    access: i.types,
                })
            })
            state.searchTypes = sTypes;
        },
        setSearchTypes: (state , action) => {
            state.searchTypes = action.payload;
        },
        setSearchStatus : (state , action) => {
            let sStatuses = [];
            SearchStatus.map((items, index) => {
                if(action.payload.map(i => {
                    if(items.access.includes(i.id) && i.status) return true;
                }).reduce((a, b) => {
                    if(a || b) return true;
                    else return false;
                })) {
                    sStatuses.push({
                        id: index,
                        name: items.name,
                        access: items.access.filter(j => {
                            return action.payload.find(t => t.id === j).status
                        })
                    })
                }
            })
            state.searchStatus = sStatuses;
        },
        changePage: (state , action) => {
            state.page = action.payload;
        },
        logOutMode: (state , action) => {
            state.page = 3;
        },
        setLoading: (state , action) => {
            state.loading = action.payload;
        },
        setDate: (state , action) => {
            state.dateSearch.loading = true;
            state.dateSearch.date = action.payload.date;
            state.dateSearch.dow = action.payload.dow;
        },
        changeCounts: (state , action) => {
            state.weeklyLimit[action.payload.index].count = action.payload.count;
        },
        changeTolerance: (state , action) => {
            state.extraCount =  action.payload;
        },
        changeTimeStatus: (state , action) => {
            state.totalTimes[action.payload.index].status = action.payload.status;
        },
        changeStatus: (state , action) => {
            state.totalStatuses[action.payload.index].status = action.payload.status;
        },
        setSelected: (state , action) => {
            state.selected = action.payload;
        },
        clearCreateNew: (state) => {
            state.create_new = {
                name: '',
                nCode: '',
                uniCode: '',
                mobile: ''
            };
        },
        setCreateNew: (state , action) => {
            state.create_new = action.payload;
        },
        setOpenStatusHistory: (state , action) => {
            state.openStatusHistory = action.payload;
        },
        setPosBanks: (state , action) => {
            state.pos = JSON.parse(action.payload);
        },
    }
})


export const { 
    setFirstData,
    setDaysLimitsData,
    setAppointmentTypes,
    setSearchTypes,
    setSearchStatus,
    changePage,
    logOutMode,
    setLoading,
    setDate,
    changeCounts,
    changeTolerance,
    changeTimeStatus,
    changeStatus,
    setSelected,
    clearCreateNew,
    setCreateNew,
    setOpenStatusHistory,
    setPosBanks,
} = globalSlice.actions;

export default globalSlice.reducer;